import React, { useEffect } from 'react';
import { ModalContent } from '@amzn/atoz-web/Modal';
import { Col } from '@amzn/atoz-web/Col';
import { useTranslation } from 'react-i18next';
import { BIAnalytics } from '@amzn/atoz-shiftapp-utilities';
import { useListOfSkills } from '../../hooks';
export var ShiftDetailsModalContent = function (_a) {
    var close = _a.close, detailsCard = _a.detailsCard, footerButtons = _a.footerButtons, shiftIntervalList = _a.shiftIntervalList, paySection = _a.paySection, specialInstructions = _a.specialInstructions, statusBanners = _a.statusBanners, shift = _a.shift, skills = _a.skills, scheduleShift = _a.scheduleShift;
    var t = useTranslation().t;
    var skillString = useListOfSkills(skills);
    useEffect(function () {
        if (scheduleShift) {
            BIAnalytics.viewScheduledShiftDetail(shift.id, shift.timeRange.start, shift.timeRange.end, skillString);
        }
        else {
            BIAnalytics.popOpenShiftDetail(shift.id, shift.timeRange.start, shift.timeRange.end, skillString);
        }
    }, []);
    return (React.createElement(ModalContent, { dataTestId: "ShiftDetailsModalContent", titleText: t('shift_management_features_ShiftDetailsModal_title'), buttons: footerButtons, onCloseButtonClick: close, closeButtonAltText: t('shift_management_common_closeModalButton') },
        React.createElement(Col, { gridGap: "S300" },
            React.createElement(Col, null,
                detailsCard,
                shiftIntervalList),
            paySection,
            specialInstructions,
            statusBanners)));
};
